if (!customElements.get('td-pdp-gallery')) {
  class TdPdpGallery extends HTMLElement {
    constructor() {
      super();
      this.formId = this.getAttribute('form-id');
      this.initial = parseInt(this.getAttribute('data-initial'), 10) || 6;
      this.optionNames = JSON.parse(this.getAttribute('data-options') || '[]');
      this.zoomId = this.getAttribute('data-zoom-id');
      this.onVariantChanged = this.onVariantChanged.bind(this);
    }

    connectedCallback() {
      this.list = this.querySelector('[data-td-gallery-list]');
      this.more = this.querySelector('[data-td-gallery-more]');
      if (this.more) {
        this.more.addEventListener('click', () => {
          const expanding = !this.classList.contains('td-pdp-gallery--expanded');
          this.classList.toggle('td-pdp-gallery--expanded', expanding);
          this.refreshVisibility();
          if (!expanding) this.scrollIntoView({ block: 'start' });
        });
      }
      const prev = this.querySelector('[data-td-gallery-prev]');
      const next = this.querySelector('[data-td-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByViewport(-1));
      if (next) next.addEventListener('click', () => this.scrollByViewport(1));
      this.onListClick = (event) => {
        const trigger = event.target.closest('[data-td-gallery-zoom]');
        if (trigger) this.openZoom(trigger.closest('[data-td-gallery-item]'));
      };
      this.list.addEventListener('click', this.onListClick);
      const zoom = this.zoomId && document.getElementById(this.zoomId);
      if (zoom && zoom.showPopover) {
        zoom.setAttribute('popover', 'manual');
        this.zoomPopoverSync = new MutationObserver(() => {
          const shown = zoom.matches(':popover-open');
          try {
            if (zoom.hasAttribute('open') && !shown) zoom.showPopover();
            else if (!zoom.hasAttribute('open') && shown) zoom.hidePopover();
          } catch (e) {
            console.warn('[td-pdp-gallery] popover sync failed', e);
          }
        });
        this.zoomPopoverSync.observe(zoom, { attributes: true, attributeFilter: ['open'] });
      }
      document.addEventListener('variant:changed', this.onVariantChanged);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariantChanged);
      if (this.list && this.onListClick) this.list.removeEventListener('click', this.onListClick);
      if (this.zoomPopoverSync) this.zoomPopoverSync.disconnect();
    }

    get items() {
      return [...this.list.querySelectorAll('[data-td-gallery-item]')];
    }

    get visibleItems() {
      return this.items.filter((el) => !el.classList.contains('is-filtered'));
    }

    scrollByViewport(direction) {
      const items = this.visibleItems;
      if (!items.length) return;
      const width = items[0].offsetWidth || this.list.clientWidth;
      const index = Math.max(0, Math.min(items.length - 1, Math.round(this.list.scrollLeft / width) + direction));
      items[index].scrollIntoView({ inline: 'start', block: 'nearest' });
    }

    openZoom(item) {
      if (!this.zoomId || !item) return;
      const zoom = document.getElementById(this.zoomId);
      if (!zoom) return;
      this.items.forEach((el) => el.classList.toggle('is-selected', el === item));
      zoom.open = true;
    }

    onVariantChanged(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      const targetId = event.target && event.target.getAttribute ? event.target.getAttribute('id') : null;
      if (targetId && targetId !== this.formId) return;
      this.applyFilter(variant);
    }

    applyFilter(variant) {
      const featuredId = variant.featured_media ? String(variant.featured_media.id) : null;
      this.items.forEach((el) => {
        const option = el.getAttribute('data-td-group-option');
        if (!option) {
          el.classList.remove('is-filtered');
          return;
        }
        const position = this.optionNames.indexOf(option);
        const selectedValue = position === -1 ? null : String(variant.options[position] || '').toLowerCase();
        const groupValue = el.getAttribute('data-td-group-value');
        const isFeatured = featuredId && el.getAttribute('data-media-id') === featuredId;
        el.classList.toggle('is-filtered', selectedValue !== groupValue && !isFeatured);
      });
      this.classList.remove('td-pdp-gallery--expanded');
      this.refreshVisibility();
      this.list.scrollTo({ left: 0 });
    }

    refreshVisibility() {
      const expanded = this.classList.contains('td-pdp-gallery--expanded');
      this.visibleItems.forEach((el, index) => {
        el.classList.toggle('td-pdp-gallery__item--extra', !expanded && index >= this.initial);
      });
      if (this.more) this.more.hidden = this.visibleItems.length <= this.initial;
    }
  }

  customElements.define('td-pdp-gallery', TdPdpGallery);
}
